import React from "react";
import FullLayout from "@/layouts/FullLayout";
import HeaderNav from "./HeaderNav";
import Scan from "./Scan";

export const KwcBins: React.FC = () => {
  return (
    <FullLayout header={<HeaderNav />}>
      <Scan />
    </FullLayout>
  );
};

export default KwcBins;
